import {inject, Injectable} from "@angular/core";
import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedelta-pos/data-client";

@Injectable()
class AppFeedbackService extends ActionService {
    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- AppFeedbackService");

        super(http, nameSpace, "app-feedback", configService, useAsync, actionNames);
    }
}

export default AppFeedbackService
